import loadable from '@loadable/component';

export const TomshardwareSiteWrapper = loadable(
  () => import(/* webpackChunkName: "tomshardware-site" */ './TomshardwareSiteWrapper'),
);
